export var SurveyErrors;
(function (SurveyErrors) {
    SurveyErrors["PatientHasActiveSurvey"] = "PatientHasActiveSurvey";
    SurveyErrors["SurveyInvalidStatusConsent"] = "SurveyInvalidStatusConsent";
    SurveyErrors["SurveyCategoryNotChosen"] = "SurveyCategoryNotChosen";
    SurveyErrors["SurveyCategoryAlreadyChosen"] = "SurveyCategoryAlreadyChosen";
    SurveyErrors["SurveyCategoryDoesNotExistForOrganization"] = "SurveyCategoryDoesNotExistForOrganization";
    SurveyErrors["SurveyLinkAlreadyFinished"] = "SurveyLinkAlreadyFinished";
    SurveyErrors["SurveyLinkAccessRevoked"] = "SurveyLinkAccessRevoked";
    SurveyErrors["SurveyStatusNotOngoing"] = "SurveyStatusNotOngoing";
    SurveyErrors["SurveyLinkNotFinished"] = "SurveyLinkNotFinished";
    SurveyErrors["SurveyLoginFailed"] = "SurveyLoginFailed";
})(SurveyErrors || (SurveyErrors = {}));
export var CommonModules;
(function (CommonModules) {
    CommonModules["AuthForm"] = "a354bc70-7875-4bbe-a201-79166d08f5bc";
    CommonModules["CSAT"] = "a6b704b6-5db5-44ef-ac97-9b93d3ee5143";
    CommonModules["ErrorSurveyAccessRevoked"] = "41c41bea-067c-4982-beeb-65b476c4e7a3";
    CommonModules["ErrorSurveyAlreadyFinished"] = "27706406-5d8d-4369-bfd4-ae1335f00f1e";
    CommonModules["ErrorDefault"] = "bc209990-5b0e-4dcb-b846-50b935ab750e";
})(CommonModules || (CommonModules = {}));
